import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { Privilege } from '@decorator/index';
import { ToasterLibraryService, CampaignReportService, HelpersService } from '@service/index';
import { NgxPermissionsService } from 'ngx-permissions';
import { Logger } from '@service/global.funcs';
import * as _ from 'lodash';

@Component({
  selector: 'app-channel-sales-bar-chart-widget',
  templateUrl: './channel-sales-bar-chart-widget.component.html',
  styleUrls: ['./channel-sales-bar-chart-widget.component.scss']
})

// @Privilege({
//   privilege: 'users:can_get_users_reports_sales'
// })
export class ChannelSalesBarChartWidgetComponent implements OnInit, OnChanges {
  @Input() relativeDate: any;
  @Input() widgetTitle = 'Sales by Campaign';
  @Input() channel = 'BUSDEV';
  @Input() chartAspectRatio: any;
  @Input() campaignData: any;

  public stackedBarChartData = [
    {
      data: [],
      label: this.widgetTitle,
      color: '#1fafff'
    }
  ];
  public barChartData = {
    labels: [],
    datasets: [
      {
        label: this.widgetTitle,
        data: []
      }
    ],
    name: this.widgetTitle,
    totalVisits: 0
  };
  public number_of_occurrences;
  public channelSalesLoaded = false;
  private total_number_occurrence = 5;
  constructor(
    private campaignReportService: CampaignReportService,
    private toasterLibrary: ToasterLibraryService,
    private permissionService: NgxPermissionsService,
    private helperService: HelpersService
  ) { }

  ngOnInit() {
    if (this.permissionService.hasPermission('users:can_get_users_reports_sales')) {
      this.getByChannel();
    }
  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    if (this.permissionService.hasPermission('users:can_get_users_reports_sales')) {
      if (
        (changes['relativeDate'] && !changes['relativeDate'].isFirstChange()) ||
        (changes['campaignData'] && !changes['campaignData'].isFirstChange()) ||
        (changes['criteriaArray'] && !changes['criteriaArray'].isFirstChange())
      ) {
        this.getByChannel();
      }
    }
  }
  getByChannel() {
    const criteriaArray: any = [
      {
        id: '',
        is_required: true,
        criterion: 'dateRange',
        value: {
          start_date: '',
          end_date: '',
          relative_date: this.relativeDate
        }
      },
      {
        id: '',
        is_required: true,
        criterion: 'channel',
        value: {
          c_channel: this.channel
        }
      }, {
        id: '',
        is_required: true,
        criterion: 'statusSubstatus',
        value: {
          ostat_id: 2,
          ss_id: 0
        }
      }
    ];

    if (this.campaignData && this.campaignData != "") {
      criteriaArray.push({
        'id': '',
        'value': { c_id: this.campaignData },
        'criterion': 'campaign',
        'is_required': true
      });
    }

    this.channelSalesLoaded = false;
    this.reInit();
    this.campaignReportService.getLeadsByCampaign(criteriaArray).subscribe(
      (res: any) => {
        Logger().info('getByChannel', 'res.data', res.data);
        if (res.success === 'true') {
          const forAggregation = res.data.slice(0);
          const afterAggregation: any = [];
          // Aggregate the data so we don't have duplicate bars for each category.
          forAggregation.forEach((record, index, theArray) => {
            if (undefined !== afterAggregation && afterAggregation.length > 0) {
              const idx = afterAggregation.findIndex(item => item.category === record.category);
              if (idx !== -1) {
                afterAggregation[idx].number_of_occurrences =
                  parseInt(afterAggregation[idx].number_of_occurrences, 10) + parseInt(record.number_of_occurrences, 10);
              } else {
                afterAggregation.push(record);
              }
            } else {
              afterAggregation.push(record);
            }
          });
          // Sort by total visits
          const byTotalVisits = afterAggregation.slice(0);
          byTotalVisits.sort(function (a, b) {
            return b.number_of_occurrences - a.number_of_occurrences;
          });

          const byTotalVisitsTop10 = _.chain(byTotalVisits)
            .sortBy(function (item) { return item.number_of_occurrences * -1; })
            .slice(0, this.total_number_occurrence)
            .value();

            byTotalVisitsTop10.forEach(record => {
            if (record.category) {
              this.stackedBarChartData[0].data.push([record.category, parseInt(record.number_of_occurrences, 10)]);
            }
          });
          Logger().info('getByChannel', 'this.stackedBarChartData', this.stackedBarChartData);
        }
        this.channelSalesLoaded = true;
      },
      err => {
        this.toasterLibrary.error(null, err.error.message);
      }
    );
  }

  exportChartData() {
    const orgId = localStorage.getItem("account_id") ?? "0";

    this.channelSalesLoaded = false
    this.helperService.chartCSVDownload(this.stackedBarChartData[0], `[${orgId}] ${this.widgetTitle}`)

    setTimeout(() => {
      this.channelSalesLoaded = true
    }, 500);
  }

  private reInit() {
    this.stackedBarChartData = [
      {
        data: [],
        label: this.widgetTitle,
        color: '#1fafff'
      }
    ];
  }
}
